import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, ViewChildren, ViewEncapsulation } from '@angular/core';
import { CoursewareQuizAnswerEditModel } from 'src/model/Test/CoursewareQuizAnswerEditModel';

@Component({
  selector: 'app-quiz-answer',
  templateUrl: './quiz-answer.component.html',
  styleUrls: ['./quiz-answer.component.css'],
  encapsulation: ViewEncapsulation.None
})

export class QuizAnswer implements OnInit {
  @Input() answer: CoursewareQuizAnswerEditModel;
  isCorrect: boolean = false;
  isIncorrect: boolean = false;
  @Output() myEvent = new EventEmitter<string>();
  @ViewChildren('myradio') radioBtns: ElementRef[];

  constructor() { }

  ngOnInit() {
  }

  getCorrectStyle() {
    if (this.isCorrect)
      return "block";
    return "none"
  }

  callParent() {
    this.myEvent.emit('eventDesc');
  }

  getIncorrectStyle() {
    if (this.isIncorrect)
      return "block";
    return "none"
  }

  showCorrectAnswer() {
    this.callParent();
    this.isCorrect = true;
    this.isIncorrect = false;
    this.radioBtns.forEach(element => {
      element.nativeElement.checked = true;
    });
  }

  showIncorrectAnswer() {
    this.callParent();
    this.isCorrect = false;
    this.isIncorrect = true;
    this.radioBtns.forEach(element => {
      element.nativeElement.checked = true;
    });
  }

  clearAnswer() {
    this.radioBtns.forEach(element => {
      element.nativeElement.checked = false;
    });
    this.isCorrect = this.isIncorrect = false;
  }

}
